import { isJsonValid } from '../validation';
import { FormValidationRule } from './types';

export function isStringJsonValidRule(): FormValidationRule {
    const errorMessage = `La chaîne de caractères doit être un JSON valide`;
    const validationRule = (value: string) => isJsonValid(value) || errorMessage;
    return { isStringJsonValid: validationRule };
}
